export const isSystemGenerated = email => /.+example.com$/.test(email)

export const matchAdminDomain = (email, adminDomain) =>
  new RegExp(adminDomain).test(email)

export const needHighlighting = (email, adminDomain) =>
  isSystemGenerated(email) ||
  (adminDomain !== null && !matchAdminDomain(email, adminDomain))
